// extracted by mini-css-extract-plugin
module.exports = {"remarkIcon":"Utils_remarkIcon__rQetv","workerName":"Utils_workerName__dvEm_"};